export const SKINS_AND_CHAMPION = {
    champion: 'champion',
    skin: 'skin',
    icon: 'icon',
};
